import { Dispatch, SetStateAction, useCallback } from 'react';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import useSocketEvent from 'services/socketService/hooks/useSocketEvent';
import { LISTEN_EVENTS } from 'services/socketService/socketEventNames';
import { FileConversionFailedEventData } from 'services/socketService/socketEventData';

type UseUpdateFailedConversionFileProps = {
  dataRoomId: string;
  setCurrentlyDisplayedNodes: Dispatch<SetStateAction<DataRoomNode[]>>;
};

const useUpdateFailedConversionFile = ({
  dataRoomId,
  setCurrentlyDisplayedNodes,
}: UseUpdateFailedConversionFileProps) => {
  const fileConversionFailed = useCallback(
    ({ dataRoomNode }: FileConversionFailedEventData) => {
      if (dataRoomId !== dataRoomNode.dataRoomId) return;

      setCurrentlyDisplayedNodes((prev) =>
        prev.map((node) =>
          node._id !== dataRoomNode._id
            ? node
            : {
                ...node,
                isProcessedSuccessfully: false,
                failedConversionToPdf: true,
              },
        ),
      );
    },
    [setCurrentlyDisplayedNodes, dataRoomId],
  );

  useSocketEvent(LISTEN_EVENTS.FILE_CONVERSION_FAILED, fileConversionFailed);
};

export default useUpdateFailedConversionFile;
